<script>
  export let exampleData;

  import { onboarded, modalActive, isMobile } from "../../stores/global.js";
  import ExampleTriangle from "./ExampleTriangle.svelte";
  import ExampleEvent from "./ExampleEvent.svelte";
  import ImpactInvestment from "../Icons/ImpactInvestment.svelte";
  import HoverKeyExpand from "../HoverKeyExpand.svelte";
  import HoverIcon from "../Icons/Hover.svelte";
  import Eye from "../Icons/Eye.svelte";
  import QuestionMark from "../Icons/Question.svelte";

  $: iconSize = $isMobile ? 20 : 35;
</script>

<div class="content">
  {#if $onboarded == "no"}<h1>Hi! First time here?</h1>
  {:else}<h1>Need some help?</h1>{/if}
  <h2>Here's a brief guide to help you to navigate this site.</h2>

  <!-- <div class="static-gradient-container"> -->
  <div class="gradient-scroll-helper" />
  <div class="scrollable-content">
    <div class="text-with-icon">
      <div class="icon">
        <ExampleTriangle width={iconSize} height={iconSize} />
      </div>
      <p>
        On this site, you'll see a series of triangles. Each triangle represents
        a <em>year</em>. The years are in reversed order, starting with the
        events you're most familiar with.
      </p>
    </div>
    <div class="text-with-icon">
      <div class="icon"><ImpactInvestment size={iconSize} /></div>
      <p>
        Each year will have a series of <em>events</em>. There are four types of
        events, and there's a <HoverKeyExpand>key</HoverKeyExpand> to help you get
        started. The larger the icon, the more 'notable' that event was.
      </p>
    </div>
    <div class="text-with-icon">
      <div class="icon"><HoverIcon size={iconSize} fill={"#262626"} /></div>
      <p>
        By clicking on an icon, you can learn more about the details for a
        particular event. Go ahead and try it below!
      </p>
    </div>
    <div class="example-event-container">
      <ExampleEvent data={exampleData} slideWidth={120} />
    </div>

    <div class="text-with-icon">
      <div class="icon">
        <Eye width={iconSize} height={iconSize} style="position: unset;" />
      </div>
      <p>
        By default, all event titles are visible for the year in focus. If
        that's overwhelming, click the eye in the corner of your screen to hide
        them until you hover.
      </p>
    </div>
    <div class="text-with-icon">
      <div class="icon">
        <QuestionMark
          size={iconSize}
          fill={"#1681a9"}
          style="position: unset;"
          inOnboard={true}
        />
      </div>
      <p>
        Need help throughout? You can access this help panel in the corner of
        your screen anytime. Have fun exploring!
      </p>
    </div>
  </div>
  <slot />
</div>

<style>
  .content {
    text-align: center;
    max-width: 768px;
    margin: auto;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    position: relative;
  }

  h2 {
    margin-top: 0.75rem;
  }

  h1 {
    font-size: 2.5rem;
    margin-top: 0.25rem;
    font-family: var(--font-subhead);
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 100;
    padding-bottom: 1rem;
    border-bottom: 1px solid white;
    font-family: var(--font-small);
  }

  .scrollable-content {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 0 10vh 0;
    scrollbar-width: thin;
    /* scrollbar-color: #bebebe #3d4682; */
  }

  .gradient-scroll-helper {
    /* height: 25vh;
    position: absolute;
    z-index: 10;
    bottom: 0;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(61, 70, 130, 0),
      rgba(61, 70, 130, 1)
    );
    pointer-events: none; */
    position: absolute;
    bottom: 2.5rem;
    width: 100%;
    height: 15vh;
    z-index: 10;
    background: linear-gradient(
      to bottom,
      rgba(61, 70, 130, 0),
      rgba(61, 70, 130, 1)
    );
    pointer-events: none;
  }

  .text-with-icon {
    max-width: 90%;
    margin: 1.5rem auto 0 auto;
  }

  .icon {
    flex-shrink: 0;
    margin: 0 !important;
    pointer-events: all;
  }

  p {
    font-weight: 200;
    text-align: left;
    font-size: 1.2rem;
    line-height: 1.25;
    font-family: var(--font-small);
  }

  .text-with-icon {
    display: flex;
    place-items: center;
  }

  .text-with-icon p {
    margin-left: 16px;
  }

  .example-event-container {
    width: 90%;
    margin: 1.5rem auto 0 7rem;
    cursor: pointer;
  }

  /* MOBILE */
  @media screen and (max-width: 767px) {
    .text-with-icon p {
      font-size: 1rem;
      margin-left: 10px;
    }

    .example-event-container {
      margin: 1rem auto;
    }

    :global(.example-event-container .expanded-content) {
      max-width: 100% !important;
      text-align: left;
    }

    :global(.example-event-container .title) {
      width: 300px !important;
    }

    h1 {
      font-size: 1.75rem;
    }

    h2 {
      font-size: 1.15rem;
      letter-spacing: 0;
    }
  }

  @media screen and (max-width: 767px) {
    h1 {
      font-size: 1.5rem;
    }

    p {
      font-size: 0.8rem;
    }

    .text-with-icon {
      margin: 1rem auto 0 auto;
    }
  }
</style>
